import React from "react";
import PropTypes from "prop-types";

const ArrowLeft = ({ page, changePage }) =>
  page === 1 ? (
    <a className="btn btn-default disabled" style={{marginRight: '5px'}}>
      <i className="material-icons progress-bar-icon">keyboard_arrow_left</i>
    </a>
  ) : (
    <a href="#" className="btn btn-default" style={{marginRight: '5px'}} onClick={changePage}>
      <i className="material-icons progress-bar-icon">keyboard_arrow_left</i>
    </a>
  );

const ArrowRight = ({ page, totalPages, changePage }) =>
  page < totalPages ? (
    <a href="#" className="btn btn-default" onClick={changePage}>
      <i className="material-icons progress-bar-icon">keyboard_arrow_right</i>
    </a>
  ) : (
    <a className="btn btn-default disabled">
      <i className="material-icons progress-bar-icon">keyboard_arrow_right</i>
    </a>
  );

const PageNumber = ({ totalPages, currentPage, number, changePage }) => {
  const changePageBy = number - currentPage

  return (
    currentPage == number ? (
      <span
        className="btn btn-primary"
        style={{margin: "0 5px 0 0", padding: '10px 15px'}}
      >
        {number}
      </span>
    ) : (
      <a
        className="btn btn-default"
        href="#"
        style={{margin: "0 5px 0 0", padding: '10px 15px'}}
        onClick={() => changePage(changePageBy)}
      >
        {number}
      </a>
    )
  )
}

const PageNumbers = ({page, totalPages, changePage}) => {
  const pageNumbers = [];
  const FlankingNumberOfPages = 5;
  const MaximumNumberOfPages = (FlankingNumberOfPages * 2) + 1;

  if((totalPages > MaximumNumberOfPages) && (page - 1 - FlankingNumberOfPages > 0)) {
    pageNumbers.push(
      <span className="btn btn-default disabled" style={{margin: "0 5px 0 0"}}>
        <i className="material-icons">more_horiz</i>
      </span>
    );
  }

  let endPageNumber = page + FlankingNumberOfPages;
  let startPageNumber = page - FlankingNumberOfPages;

  if(endPageNumber > totalPages) {
    endPageNumber = totalPages;
    startPageNumber = endPageNumber - MaximumNumberOfPages + 1;
    if(startPageNumber < 1) {
      startPageNumber = 1;
    }
  }

  if(startPageNumber < 1) {
    startPageNumber = 1;
    endPageNumber = startPageNumber + MaximumNumberOfPages - 1;
    if(endPageNumber > totalPages) {
      endPageNumber = totalPages;
    }
  }

  for(let i = startPageNumber; i <= endPageNumber; i += 1) {
    pageNumbers.push(
      <PageNumber
        key={i}
        totalPages={totalPages}
        currentPage={page}
        number={i}
        changePage={changePage}
      />
    );
  }

  if((totalPages > MaximumNumberOfPages) && (totalPages - page - FlankingNumberOfPages > 0)) {
    pageNumbers.push(
      <span className="btn btn-default disabled" style={{margin: "0 5px 0 0"}}>
        <i className="material-icons">more_horiz</i>
      </span>
    );
  }

  return (<span>{pageNumbers}</span>)
}

const Pagination = ({ totalPages, page, changePage }) => (
  <div>
    <p>{`Showing page ${page} of ${totalPages}`}</p>

    <ArrowLeft page={page} changePage={() => changePage(-1)} />

    <PageNumbers
      page={page}
      totalPages={totalPages}
      changePage={changePage}
    />

    <ArrowRight
      page={page}
      totalPages={totalPages}
      changePage={() => changePage(1)}
    />
  </div>
);

ArrowLeft.propTypes = {
  page: PropTypes.number,
  changePage: PropTypes.func
};

ArrowLeft.defaultProps = {
  page: 0
};

ArrowRight.propTypes = {
  page: PropTypes.number,
  totalPages: PropTypes.number,
  changePage: PropTypes.func
};

ArrowRight.defaultProps = {
  page: 0,
  totalPages: 0
};

PageNumber.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  number: PropTypes.number,
  changePage: PropTypes.func
};

PageNumber.defaultProps = {
  currentPage: 0,
  totalPages: 0,
  number: 0
};

PageNumbers.propTypes = {
  page: PropTypes.number,
  totalPages: PropTypes.number,
  changePage: PropTypes.func
};

PageNumbers.defaultProps = {
  page: 0,
  totalPages: 0
};

Pagination.propTypes = {
  totalPages: PropTypes.number,
  page: PropTypes.number,
  changePage: PropTypes.func
};

Pagination.defaultProps = {
  page: 0,
  totalPages: 0
};

export default Pagination;
